import {
  PageContainer,
  PageHeader,
  PageSlideSidebar,
  PageBody,
  PageContent,
} from './components'

// Composing pattern
export const Page = {
  Container: PageContainer,
  Header: PageHeader,
  Body: PageBody,
  Content: PageContent,
  SlideSidebar: PageSlideSidebar,
}
